// import React, { useContext, useEffect, useState } from 'react'
// import '../App.css'; 
// import { Context } from '../ContextApi/ContextApi';
// import { useNavigate } from 'react-router-dom';
// import Api from '../services/AuthService';
// export default function Login() {
//   const {loginApi}= Api() 
//     const {user,setUser} =useContext(Context)
//     const navigate = useNavigate()
//     const [show, setShow]=useState(false)
//     const [error,setError]=useState();
//     useEffect(()=>{
//       const storedUser = JSON.parse(localStorage.getItem('user'));
//       if (storedUser && storedUser.loggedIn) {
//           setUser(storedUser);
//           navigate('/');
//       }
//   }, [setUser, navigate]);
//     const Submit = async(e)=>{
//         e.preventDefault();
//         const res =  await loginApi(e.target.name.value,e.target.pass.value)
//         console.log(res);
        
//         if(res){
//           navigate('/admin')
        
//         }
//       else{
//           setError("Name Pass False")
//       }
//     } 
//   return (
//     <div>
//     <form className="sign" onSubmit={e=>Submit(e) }>
//       <h1>Sign in</h1>
//       <input placeholder="First name" name='name'
//       //  onChange={x=> setuser((prev) => ({ ...prev, name: x.target.value}))}
//         />
//       <input type={show ? "text":"password"} name="pass" placeholder="Password"   classNamee="pass"></input>
//       <i onClick={()=>{setShow(!show); console.log(show);
//       }} className={show ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"}></i>
//       <br></br>
//       <button>Enter</button>
//       <a href="/Login/Registr">Registr</a>
//   </form>
//     </div>
//   )
// }
import style from './index.module.css'
import React, { useState, useContext, useEffect } from "react";
import { login } from '../../services/AuthService';
import { useNavigate } from 'react-router-dom';
import { Context } from '../../ContextApi/ContextApi';

const Login = () => {
  const { user, setUser } = useContext(Context);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // localStorage-dan istifadəçi məlumatlarını yoxlamaq
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const storedAccessToken = localStorage.getItem("accessToken");

    // Əgər istifadəçi məlumatları varsa, onları istifadə et və yönləndir
    if (storedUser && storedAccessToken) {
      setUser(storedUser); // Context-də istifadəçi məlumatlarını saxla
      // İstifadəçi artıq daxil olubsa, ana səhifəyə yönləndir
      navigate("/");
    }
  }, [navigate, setUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!name.trim() || !password.trim()) {
      setError("Həm istifadəçi adı, həm də şifrə tələb olunur.");
      return;
    }
    setLoading(true);
    try {
      const response = await login({ name, password });
      const uss = {
        name: response.userFullName,
        loggedIn: true,
        role: response.userStatusId,
        userId: response.userId
      }
      setUser({
        name: response.userFullName,
        loggedIn: true,
        role: response.userStatusId,
        userId: response.userId
      });

      console.log("Giriş uğurludur:", response);
      // localStorage-a məlumatları düzgün şəkildə saxla
      localStorage.setItem("accessToken", response.accessToken);
      localStorage.setItem("refreshToken", response.refreshToken);
      localStorage.setItem("userId", response.userId);
      localStorage.setItem("user", JSON.stringify(uss));

      alert("Giriş uğurludur!");
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className={style.form}>
        <div className={style.img}>
          <a href=''><img src='https://new.axilthemes.com/demo/template/etrade/assets/images/logo/logo.png' alt="Logo" /></a>
        </div>
        <div className={style.sign}>
          <p>Hələ üzv deyilsiniz? <a href='/Registr'>İndi üzv olun</a></p>
        </div>
      </div>
      <div className={style.sign1}>
        <h2>eTrade-ə daxil olun.</h2>
        <p>Aşağıdakı məlumatları daxil edin</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={style.group}>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>İstifadəçi adı:</label>
        </div>

        <div className={style.group}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span className={style.highlight}></span>
          <span className={style.bar}></span>
          <label>Şifrə:</label>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <button className={style.button} type="submit" disabled={loading}>
          {loading ? "Yüklənir..." : "Daxil ol"}
          <a href='/Forget'>Şifrəni unutmusunuz?</a>
        </button>
      </form>
      <div className={style.form1}>
        <p>Ən Yaxşı Məhsulları Təklif Edirik</p>
      </div>
      <div className={style.hed}></div>
    </div>
  )
}
export default Login;
